import * as ViewerCache from '../utils/ViewerCache';
export const configureViewerCacheMiddleware = actionType => () => next => action => {
  if (action.type === actionType) {
    ViewerCache.set(action.payload.toJS());
  }
  return next(action);
};